import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ReleaseNotesService } from '../../services/release-notes.service';
import { ReleaseNote } from '@pulpo/pulpo-models';

@Component({
  selector: 'version-update-snackbar',
  templateUrl: './version-update-snackbar.component.html',
  styleUrls: ['./version-update-snackbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class VersionUpdateSnackbarComponent implements OnInit {
  latestReleaseNote: ReleaseNote | null = null;

  constructor(
    public snackBarRef: MatSnackBarRef<VersionUpdateSnackbarComponent>,
    private router: Router,
    private releaseNotesService: ReleaseNotesService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.releaseNotesService.getLatestReleaseNote().subscribe((note) => {
      this.latestReleaseNote = note;
      this.cdr.markForCheck();
    });
  }

  reload() {
    window.location.reload();
  }

  goToReleaseNotes() {
    this.snackBarRef.dismiss();
    this.router.navigate(['/release-notes']);
  }
}
